var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-b-pending"},[_c('div',{staticClass:"wrapper-timeline b-proposal"},[_c('div',{staticClass:"progress-box"},[_c('p',[_vm._v(_vm._s(_vm.date))]),_c('h2',[_vm._v("Creator contratado/a")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }